import { cloudDisplayModeDefaultOptions } from '../../../components/Tags/constants';
export function restrictToPositiveNumber(value) {
  return value <= 0 ? cloudDisplayModeDefaultOptions.maxLines : value;
}